import { render, staticRenderFns } from "./MotorbikeCharts.vue?vue&type=template&id=dc0c71c8&scoped=true&"
import script from "./MotorbikeCharts.vue?vue&type=script&lang=js&"
export * from "./MotorbikeCharts.vue?vue&type=script&lang=js&"
import style0 from "./MotorbikeCharts.vue?vue&type=style&index=0&id=dc0c71c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c71c8",
  null
  
)

export default component.exports